import { Action } from '@ngrx/store';


export enum EFilterUsersActions {
  FilterUsers = '[Filter users] Apply Filter User',
  FilterUsersSuccess = '[Filter users]  Apply Filter Users Success',
  GetFilterColumns = '[Filter columns] Get Filter Columns',
  GetFilterColumnsSuccess = '[Filter columns] Get Filter Columns Success',
}

export class FilterUsers implements Action {
  public readonly type = EFilterUsersActions.FilterUsers;
  constructor(public payload: {filterColumn: string, valueToSearch: string}) {}
}

export class FilterUsersSuccess implements Action {
  public readonly type = EFilterUsersActions.FilterUsersSuccess;
  constructor(public payload: ISpecificUser[]) {}
}

export class GetFilterColumns implements Action {
  public readonly type = EFilterUsersActions.GetFilterColumns;
}

export class GetFilterColumnsSuccess implements Action {
    public readonly type = EFilterUsersActions.GetFilterColumnsSuccess;
    constructor(public payload: string[]) {}
  }

export type FilterUserActions = FilterUsers | FilterUsersSuccess | GetFilterColumns | GetFilterColumnsSuccess;
